const deviceValidationRulesMixin = {
  computed: {
    validationRules() {
      return {
        name: [
          v => !!v || this.$t('validationMessages.device.name.required'),
          v => (v && v.length <= 50) || this.$t('validationMessages.device.name.maxLength', { maxLength: 50 }),
        ],
        imei: [
          v => !!v || this.$t('validationMessages.device.imei.required'),
          v => (v && v.length <= 20) || this.$t('validationMessages.device.imei.maxLength', { maxLength: 20 }),
        ],
        simPhoneNumber: [
          v => (v.length <= 50) || this.$t('validationMessages.device.simPhoneNumber.maxLength', { maxLength: 50 }),
        ],
        type: [
          v => (v !== null && v !== undefined) || this.$t('validationMessages.device.type.required'),
        ],
        refreshRate: [
          v => (v === '' || (v > 0 && v < 25)) || this.$t('validationMessages.device.refreshRate.valueBetween', { max: 24, min: 1 })
        ],
        refreshRateWithNullChecker: [
          v => (v > 0 && v < 25) || this.$t('validationMessages.device.refreshRate.valueBetween', { max: 24, min: 1 })
        ],
        externalDeviceId: [
          v => !!v || this.$t('validationMessages.device.externalDeviceId.required')
        ]
      }
    }
  }
}

export default deviceValidationRulesMixin;